export enum LiveSourceTypes {
  Kaltura = 'Kaltura',
  Livestream = 'Livestream',
  Zoom = 'Zoom',
}
